import { type Registry as Services, service } from '@ember/service';
import BaseController from 'uplisting-frontend/pods/base/controller';

export default class ReportsController extends BaseController {
  @service features!: Services['features'];
}
